import React from "react";
// import DepatureDetail from "./DepatureDetail";
import "./FareRuleMobile.css";
const FareRulesMobile = ({
  fareRuleLoad,
  setFareRuleLoad,
  fareRule,
  loadingFareRule,
}) => {
  return (
    <div className="mobile heading_flight_list_two">
      <div className="actpop fltr-pop" id="idflr" ng-show="isFilt">
        <div className="popbx fareRule_popbxmobile">
          <div
            className="close-btn fltPop"
            onClick={() => setFareRuleLoad(false)}
          >
            ✕
          </div>
          <div className="modal-content-review slideUpani">
            <div className="scrollmenu">
              <ul className="tabsn">
                {/* <li className="tab-link current-n ng-scope">
                  <img
                    src="https://flight.easemytrip.com/M_Content/img/NewTravImg/money-saving.svg"
                    alt=""
                  />{" "}
                  BreakUp
                </li> */}

                <li className="tab-link ng-scope current-n ">
                  <img
                    src="https://flight.easemytrip.com/M_Content/img/NewTravImg/money-thumb.svg"
                    alt=""
                  />
                  Fare Rules
                </li>

                {/* <li className="tab-link">
                  <img
                    src="https://flight.easemytrip.com/M_Content/img/NewTravImg/suitcase.svg"
                    alt=""
                  />{" "}
                  Baggage
                </li> */}
              </ul>
            </div>
            <div className="review_scroll">
              {loadingFareRule ? (
                <div className="text-center py-3">Loading Fare Rule...</div>
              ) : (
                <>
                  {fareRule.length > 0 && (
                    <div
                      className="m-info-tips2 mar20"
                      style={{ display: "block" }}
                    >
                      <div
                        className="left_gtk"
                        style={{
                          maxHeight: "300px",
                          overflow: "auto",
                          scrollbarWidth: "thin",
                        }}
                      >
                        <ul>
                          {fareRule.map((item, index) => (
                            <li key={index} className="m-info-tips2_item">
                              <p className="txt-sb">{item}</p>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FareRulesMobile;
